import { render, staticRenderFns } from "./NbProductTypeAhead.vue?vue&type=template&id=7bfdc44b&"
import script from "./NbProductTypeAhead.vue?vue&type=script&lang=js&"
export * from "./NbProductTypeAhead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports